import Order from "../interfaces/Order";
import OrderDetails from "../interfaces/OrderDetails";
import RequestModalConfig from "../interfaces/RequestModalConfig";
import { ModalTypeEnum } from "@/enums/modalTypeEnum";
import { OrderDetailsResponse } from "../interfaces/response/OrderDetailsResponse";

class ModalHelper {
  static getRequestModalConfig(
    order: Order | OrderDetails,
    type: ModalTypeEnum
  ): RequestModalConfig {
    const config = modalConfigMap[type];

    if (!config) {
      throw new Error(`Unknown modal type: ${type}`);
    }

    return {
      id: order.orderNumber ?? "",
      branchEmail: order.branchEmail,
      userEmail: order.userEmail,
      ...config,
    };
  }

  static getRequestModalOrderDetailsConfig(
    order: OrderDetailsResponse,
    type: ModalTypeEnum
  ): RequestModalConfig {
    const config = modalConfigMap[type];

    if (!config) {
      throw new Error(`Unknown modal type: ${type}`);
    }

    return {
      id: order.customOrderNumber,
      branchEmail: order.contactEmail,
      userEmail: order.userEmail,
      ...config,
    };
  }
}

const modalConfigMap: Record<
  ModalTypeEnum,
  {
    dialogTitle: string;
    subjectPrefix: string;
    promptText: React.ReactNode;
    commentsLabel: string;
    statusChange: boolean;
    returnRequest: boolean;
  }
> = {
  [ModalTypeEnum.OrderChange]: {
    dialogTitle: "REQUEST ORDER CHANGE",
    subjectPrefix: "Change Order Request",
    promptText: (
      <>
        Please enter the change(s) you would like to make to this order. Your
        branch team will contact you about accommodating your request.
        <br />
        <br />
        *Change examples may include but are not limited to: adding products,
        updates to UOM or color(s), adjusting delivery dates/times, or requests
        to cancel.
      </>
    ),
    commentsLabel: "What would you like to change about your order?",
    statusChange: false,
    returnRequest: false,
  },

  [ModalTypeEnum.StatusUpdate]: {
    dialogTitle: "REQUEST STATUS UPDATE",
    subjectPrefix: "Status Update Request",
    promptText: (
      <>
        If you would like an update on the status of this order please click
        send below and one of our associates will reach out to you.
      </>
    ),
    commentsLabel: "Any Comments?",
    statusChange: true,
    returnRequest: false,
  },

  [ModalTypeEnum.QuoteChange]: {
    dialogTitle: "REQUEST QUOTE UPDATE",
    subjectPrefix: "Change Quote Request",
    promptText: (
      <>
        Please enter the change(s) you would like to make to this quote. Your
        branch team will contact you about accommodating your request.
        <br />
        <br />
        *Change examples may include but are not limited to: adding products,
        updates to UOM or color(s), adjusting delivery dates/times, or requests
        to cancel.
      </>
    ),
    commentsLabel: "What would you like to change about your quote?",
    statusChange: false,
    returnRequest: false,
  },

  [ModalTypeEnum.InvoiceChange]: {
    dialogTitle: "REQUEST INVOICE UPDATE",
    subjectPrefix: "Change Invoice Request",
    promptText: (
      <>
        Please enter the change(s) you would like to make to this invoice. Your
        branch team will contact you about accommodating your request.
        <br />
        <br />
        *Change examples may include but are not limited to: adding products,
        updates to UOM or color(s), adjusting delivery dates/times, or requests
        to cancel.
      </>
    ),
    commentsLabel: "What would you like to change about your invoice?",
    statusChange: false,
    returnRequest: false,
  },

  [ModalTypeEnum.SapOrderReturn]: {
    dialogTitle: "REQUEST ORDER RETURN",
    subjectPrefix: "Return Order Request",
    promptText: <> </>,
    commentsLabel: "Any Comments?",
    statusChange: false,
    returnRequest: true,
  },
};

export default ModalHelper;
